import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import {
  Btns,
  ButtonL,
  Content,
  FlexBox,
  Section,
  TextDiv,
} from "../../styles/Common";
import { ReactComponent as MupointBtn } from "../../styles/images/mupoint.svg";
import HandImg from "../../styles/images/img_hand.png";
import { styled } from "styled-components";
import OnePageLayout from "../../components/layout/OnePageLayout";
import OnlyHeaderLayout from "../../components/layout/OnlyHeaderLayout";

const SignUpResult = () => {
  let navigate = useNavigate();
  return (
    <OnlyHeaderLayout title="가입 완료">
      <Section>
        <Content>
          <TextDiv>
            <h3>뮤포인트 회원에 정상적으로 가입되었습니다.</h3>
          </TextDiv>
          <ImgWarp>
            <MupointBtn />
            <img src={HandImg} alt="" className="handImg" />
          </ImgWarp>
        </Content>
        <Btns>
          <ButtonL
            onClick={() => {
              navigate("/");
            }}
          >
            확인
          </ButtonL>
        </Btns>
      </Section>
    </OnlyHeaderLayout>
  );
};

export default SignUpResult;

const ImgWarp = styled.div`
  margin-top: 5rem;
  text-align: center;
  .handImg {
    width: 23.7rem;
    margin-top: 1.8rem;
  }
`;
